import {
  DEFAULT_SECTION_1,
  DEFAULT_SECTION_2,
  DEFAULT_SECTION_3,
  DEFAULT_SECTION_4,
  DEFAULT_SECTION_5,
  DEFAULT_SECTION_6,
  DEFAULT_SECTION_7,
} from "@/constants/sections";
import { type TDashboardFeatureConfig } from "./BaseSectionDashboard";

/**
 * Default feature configuration for unknown sections.
 */
const DEFAULT_CONFIG: TDashboardFeatureConfig = {
  showCompanyKnowledge: false,
  showCategoriesTools: true,
  showChat: false,
  showInvestorReadinessTodos: false,
};

/**
 * Registry mapping section IDs to their feature configurations.
 * This is the single source of truth for which features each section has enabled.
 */
const SECTION_DASHBOARD_CONFIGS: Record<string, TDashboardFeatureConfig> = {
  [DEFAULT_SECTION_1]: {
    showCompanyKnowledge: true,
    showCategoriesTools: true,
    showChat: false,
  },
  [DEFAULT_SECTION_2]: {
    showCompanyKnowledge: false,
    showCategoriesTools: true,
    showChat: false,
    showInvestorReadinessTodos: true,
  },
  [DEFAULT_SECTION_3]: {
    showCompanyKnowledge: false,
    showCategoriesTools: true,
    showChat: false,
  },
  [DEFAULT_SECTION_4]: {
    showCompanyKnowledge: false,
    showCategoriesTools: true,
    showChat: false,
  },
  [DEFAULT_SECTION_5]: {
    showCompanyKnowledge: false,
    showCategoriesTools: true,
    showChat: false,
  },
  [DEFAULT_SECTION_6]: {
    showCompanyKnowledge: false,
    showCategoriesTools: true,
    showChat: false,
  },
  [DEFAULT_SECTION_7]: {
    showCompanyKnowledge: false,
    showCategoriesTools: false,
    showChat: false,
  },
};

/**
 * Get the dashboard feature configuration for a given section ID.
 *
 * @param sectionId - The section ID to get the configuration for
 * @returns The feature configuration for the section, or default configuration if section ID is unknown
 */
export function getDashboardConfig(sectionId: string | null): TDashboardFeatureConfig {
  if (!sectionId) {
    return DEFAULT_CONFIG;
  }

  return SECTION_DASHBOARD_CONFIGS[sectionId] ?? DEFAULT_CONFIG;
}
